module.exports = __webpack_public_path__ + "assets/trash.svg?8d2d7c1f052d80b41599a828a9650712";